module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods-info"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left search flex flex-align-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goods),
      expression: "goods"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入配品名"
    },
    domProps: {
      "value": (_vm.goods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goods = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search",
    on: {
      "click": _vm.searchGoods
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search",
    style: ({
      display: (_vm.goodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.curGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.goodCheckArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item, 'search')
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fliter type"
  }, [_vm._v("\n                        分类选择：\n                        "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.fliter_type),
      callback: function($$v) {
        _vm.fliter_type = $$v
      },
      expression: "fliter_type"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.systemData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "fliter"
  }, [_vm._v("\n                        管理库存：\n                        "), _c('el-select', {
    model: {
      value: (_vm.fliter_stock),
      callback: function($$v) {
        _vm.fliter_stock = $$v
      },
      expression: "fliter_stock"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    key: "true",
    attrs: {
      "label": "是",
      "value": "true"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "false",
    attrs: {
      "label": "否",
      "value": "false"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "left searchBtn",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('button', {
    staticStyle: {
      "padding": "0 10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fliterGoods
    }
  }, [_vm._v("筛选")])]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addGoods
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加配品")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.vipData.length > 6
    }
  }, _vm._l((_vm.vipData), function(item, idx) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "4%"
      },
      domProps: {
        "textContent": _vm._s(item.id ? (idx + 1) : '')
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      },
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('el-button', {
      attrs: {
        "type": "text",
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.uploadGood(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delGoods(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })])], 1) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "title": _vm.btnId ? '修改配品' : '添加配品',
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix",
    on: {
      "click": _vm.hideSearchList
    }
  }, [_c('div', {
    staticClass: "left msgItem clearfix searchbox"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("配品名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.name),
      expression: "newGoods.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入配品名"
    },
    domProps: {
      "value": (_vm.newGoods.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search add_details_search",
    style: ({
      display: (_vm.addGoodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.addCurGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.addGoodCheckArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item, 'add')
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("配品分类")]), _vm._v(" "), _c('el-select', {
    staticClass: "itemSelect",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "placeholder": "请选择配品分类"
    },
    model: {
      value: (_vm.newGoods.productTypeId),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "productTypeId", $$v)
      },
      expression: "newGoods.productTypeId"
    }
  }, [_vm._l((_vm.systemData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("价格")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.salesPrice),
      expression: "newGoods.salesPrice"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "50px",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "价格"
    },
    domProps: {
      "value": (_vm.newGoods.salesPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "salesPrice", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left"
  }, [_vm._v("元")])]), _vm._v(" "), _c('div', {
    staticClass: "left mat-goods"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("包含原料:")]), _vm._v(" "), _c('span', {
    staticClass: "seled-mat-list"
  }, _vm._l((_vm.seledMats), function(tag) {
    return _c('el-tag', {
      key: tag.name
    }, [_vm._v("\n                        " + _vm._s(tag.name) + "*" + _vm._s(tag.count) + "\n                        ")])
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addMatGoods
    }
  }, [_vm._v("+添加")])], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.upGoods
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMat) ? _c('selGoods', {
    attrs: {
      "seledGoods": _vm.seledMats,
      "storeId": _vm.curStoreId
    },
    on: {
      "selOk": _vm.selOk,
      "closeSelGoods": function($event) {
        _vm.showMat = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("配品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("销售价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-49017f1e","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/peiGoods/info.vue
// module id = 942
// module chunks = 1